import { Controller } from "@hotwired/stimulus"
import i18n from "../javascripts/util/i18n"

// Keeps a file-download form's dialog open with a busy button while the server
// builds the file. A native download triggers no navigation and no load event,
// so completion is signalled by the server echoing our token back in a cookie
// (see Backoffice::DocumentsController#generate).
export default class extends Controller {
  static targets = ["button", "token"]
  static values = {
    cookie: { type: String, default: "file_download" },
    label: String,
    timeout: { type: Number, default: 180000 },
  }

  submit() {
    if (this.busy) return
    this.busy = true
    this.token = `${Date.now()}-${Math.random().toString(36).slice(2)}`
    if (this.hasTokenTarget) this.tokenTarget.value = this.token

    this.originalHtml = this.buttonTarget.innerHTML
    this.buttonTarget.disabled = true
    this.buttonTarget.innerHTML =
      `<svg class="h-4 w-4 animate-spin" fill="none" viewBox="0 0 24 24"><circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle><path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path></svg><span>${this.escape(this.labelValue || i18n.t("js.download_form.generating"))}</span>`

    this.poller = setInterval(() => this.checkCookie(), 400)
    // Safety net: if the signal never arrives, give the button back but leave
    // the dialog open so the user can retry.
    this.timer = setTimeout(() => this.finish({ close: false }), this.timeoutValue)
  }

  checkCookie() {
    const match = document.cookie.match(new RegExp(`(?:^|; )${this.cookieValue}=([^;]*)`))
    if (match && decodeURIComponent(match[1]) === this.token) this.finish()
  }

  finish({ close = true } = {}) {
    clearInterval(this.poller)
    clearTimeout(this.timer)
    document.cookie = `${this.cookieValue}=; Max-Age=0; path=/`
    this.busy = false
    this.buttonTarget.disabled = false
    if (this.originalHtml !== undefined) this.buttonTarget.innerHTML = this.originalHtml
    if (close) this.element.closest("dialog")?.close()
  }

  disconnect() {
    clearInterval(this.poller)
    clearTimeout(this.timer)
  }

  escape(value) {
    return String(value).replace(/[&<>"']/g, (c) =>
      ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c])
    )
  }
}
